export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 25;

export const PASSWORD_VALIDATION_REGEX = new RegExp(
  `^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{${PASSWORD_MIN_LENGTH},${PASSWORD_MAX_LENGTH}}$`
);
export const EMAIL_VALIDATION_REGEX =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
export const NUMBER_VALIDATION_REGEX = /^(?=.*\d).{1,}$/;
export const CHARACTER_VALIDATION_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{2,}$/;

export enum USER_ROLES {
  PRIVATE,
  COMMERCIAL,
}

export const SIGNIN_ERRORS = {
  SessionRequired: 'login.sessionRequiredError',
};

// This is a mock error message for login error
// TODO: it should be removed as it has to come from ACE
export const LOGIN_ERROR =
  // eslint-disable-next-line quotes
  "Incorrect password. Please try again or click 'Forgot Password' to reset it.";
